<template>
    <div v-if="hasChildren" class="flex flex-col w-60 max-h-[230px] overflow-x-hidden bg-white">
        <div class="flex gap-4 items-center px-4 py-2">
            <span class="text-xs text-gray-90">{{ menu.title }}</span>
            <i class="flex-1 h-[1px] bg-gray-40" />
        </div>
        <div class="flex-1 overflow-y-auto flex flex-col text-sm gap-0.5 text-black">
            <component
                :is="subComponent"
                v-for="child in menu.children"
                :key="child.id"
                :child="child"
                :in-tooltip="true"
            />

            <a
                v-if="isHistory && menu?.children?.length > 5"
                class="text-sm text-primary ml-4 mt-2 mb-2 hover:underline"
                href="/history"
                target="_blank"
            >
                {{ t('NavBar.ALL_HISTORY') }}
            </a>
        </div>
    </div>
    <div v-else class="cursor-pointer whitespace-nowrap">
        {{ menu.title }}
    </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import _ from 'lodash';
import type { IMenuItem } from '../types';
import SubItem from './SubItem.vue';
import HistorySubItem from './HistorySubItem.vue';
import { HISTORY_KEY } from '../constants';
import { useI18n } from 'vue-i18n';
import { cn, en, jp, tw } from '../locales';

const { t } = useI18n({
    messages: {
        cn, en, jp, tw,
    },
});

const props = defineProps<{
    menu: IMenuItem;
}>();

const hasChildren = computed(() => _.size(props.menu?.children) > 0);
const subComponent = computed(() => {
    if (props.menu.id === HISTORY_KEY) {
        return HistorySubItem;
    }
    return SubItem;
});
const isHistory = computed(() => props.menu.id === HISTORY_KEY);
</script>
